import React, { useContext, useEffect, useState } from "react";
import "./style.scss";
import Button from "../../../common/Button";
import { message, Modal, Pagination, Table, Upload } from "antd";
import {
  useCreateNewBatch,
  useGetAllBatches,
  useGetBatchOverview,
  useGetBatchCSV,
} from "../../../hooks/useOrderBatches";
import { Link, useNavigate } from "react-router-dom";
import {
  UploadFileContext,
  useUpload,
} from "../../../context/uploadFileContext";
import CSVDetails from "../CSVDetails";
import { BatchMarketPlaceContext } from "../../../context/batchProvider";
import PayFromWallet from "../../../common/PayFromWallet";
import { UserWalletContext } from "../../../context/userWalletContext";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import cancelIcon from "../../../assets/Common/cancelIcon.svg";
import successIcon from "../../../assets/Common/SuccessTick.svg";
import pendingIcon from "../../../assets/Common/pendingIcon.svg";
import { SourceProviderContext } from "../../../context/sourceProvider";

const OrderList = () => {
  const [usersList, setUsersList] = useState([]);
  const [pageSize, setPageSize] = useState(15);
  const [pageNum, setPageNum] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [draftBatchId, setDragBatchId] = useState();
  const [showMenu, setShowMenu] = useState(false);
  const [menuVisibleId, setMenuVisibleId] = useState(null);
  const [selectedRecordId, setSelectedRecordId] = useState(null);
  const [showAddBatchModal, setShowAddBatchModal] = useState(false);
  const [batchName, setBatchName] = useState("");
  const [showStatus, setShowStatus] = useState(null);
  const [showProdStatus, setShowProdStatus] = useState(false);
  const [orderOverview, setOrderOverview] = useState();
  const navigate = useNavigate();
  const { sourceData } = useContext(SourceProviderContext);

  const {
    batch_setSelectedMarketPlaces,
    batch_setSelectedCategoryName,
    batch_setSelectedCategoryId,
    batch_setSelectedSubCategoryId,
    batch_setSelectedSubCategoryName,
    batch_setSelectedAddOnServices,
  } = useContext(BatchMarketPlaceContext);

  const { setUploadedFolders } = useContext(UploadFileContext);

  const [showPayModal, setShowPayModal] = useState(false);
  const {
    walletDetails,
    getWalletAccountDetails,
    setSelectedOrderForPayment,
    selectedOrderForPayment,
    setOpenRechargeWalletModal,
  } = useContext(UserWalletContext);
  useEffect(() => {
    batch_setSelectedMarketPlaces([]);
    batch_setSelectedCategoryName("");
    batch_setSelectedCategoryId("");
    batch_setSelectedSubCategoryId("");
    batch_setSelectedSubCategoryName("");
    batch_setSelectedAddOnServices([]);
    setUploadedFolders([]);
  }, []);

  const handleShowMenu = (id) => {
    setMenuVisibleId((prevId) => (prevId === id ? null : id));
    setSelectedRecordId(id);
  };

  const columns = [
    {
      title: "Batch No.",
      key: "batchNumber",
      align: "left",
      dataIndex: "batchNumber",
      render: (_, record, index) => {
        return (
          <div className="">
            {record?.batchNumber ? record?.batchNumber : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Batch Name",
      key: "name",
      align: "left",
      dataIndex: "name",
      render: (_, record, index) => {
        return (
          <div className="">
            {`${record?.name} ${
              record?.lastName != null ? record?.lastName : ""
            }` || ""}
          </div>
        );
      },
    },
    {
      title: "Order Created",
      key: "deliveredSkus",
      align: "center",
      dataIndex: "deliveredSkus",
      render: (_, record, index) => {
        return (
          <div>
            {record?.batchCreationAt
              ? new Date(record?.batchCreationAt).toISOString().split("T")[0]
              : "-"}
          </div>
        );
      },
    },
    {
      title: "Total No. of Skus",
      key: "NoOfSkus",
      align: "center",
      dataIndex: "NoOfSKus",
      render: (_, record, index) => {
        return <div>{record?.totalDraftSkus || record?.totalSkus || 0}</div>;
      },
    },
    {
      title: "Delivered Skus",
      key: "deliveredSkus",
      align: "center",
      dataIndex: "deliveredSkus",
      render: (_, record, index) => {
        return <div>{record?.deliveredSkus || 0}</div>;
      },
    },

    {
      title: "Status",
      key: "status",
      align: "center",
      dataIndex: "status",
      render: (_, record) => {
        return (
          <div className="status_wrapper">
            {record?.displayStage}
            {showStatus === record?._id ? (
              <EyeInvisibleOutlined onClick={() => setShowStatus(null)} />
            ) : (
              <EyeOutlined onClick={() => setShowStatus(record?._id)} />
            )}
            {showStatus === record?._id && (
              <div className="status_main_container">
                <div className="heading">Status Detail</div>
                <div className="status_details_container">
                  {record?.unifiedSkus?.map((unifiedSku, index) => {
                    return (
                      <div className="status_wrapper">
                        <div className="status_name">
                          {unifiedSku?.displayStage}
                        </div>
                        <div className="status_details">
                          <div className="details">
                            <img src={successIcon} alt="successIcon" />
                            {unifiedSku?.count?.Completed || 0}
                          </div>
                          <div className="details">
                            <img src={cancelIcon} alt="cancelIcon" />
                            {unifiedSku?.count?.Rejected || 0}
                          </div>
                          <div className="details">
                            <img src={pendingIcon} alt="pendingIcon" />
                            {unifiedSku?.count?.Pending || 0}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        );
      },
    },

    {
      title: "Action",
      key: "actions",
      align: "center",
      dataIndex: "actions",
      render: (_, record) => {
        return record?.stage === "orderCreation" ? (
          <Link to={`/upload-images/${record?._id}`}>Resume</Link>
        ) : record?.stage === "payment" ? (
          <Link
            onClick={() => {
              handlePayment(record);
            }}
          >
            Pay
          </Link>
        ) : (
          ""
        );
      },
    },
    {
      title: "",
      key: "...",
      align: "center",
      dataIndex: "actions",
      render: (_, record) => {
        const isMenuVisible = menuVisibleId === record?._id;
        return (
          <div
            className="show_menu"
            onClick={() =>
              record.stage != "orderCreation" && handleShowMenu(record?._id)
            }
          >
            ...
            {isMenuVisible && (
              <div className="manage_item">
                {!!record.csvAttachment && record.csvAttachment.length > 0 && (
                  <button
                    onClick={() => {
                      setShowMenu(true);
                    }}
                  >
                    Manage CSV
                  </button>
                )}
                {record?.flixitBatchUrl && (
                  <button
                    className="view_on_flixit"
                    onClick={() => {
                      window.open(`${record.flixitBatchUrl}`, "_blank");
                    }}
                  >
                    View on Flixit
                  </button>
                )}
                {record.stage != "orderCreation" && (
                  <button
                    className="download_csv"
                    onClick={() => {
                      getBatchCSV(record?._id);
                    }}
                  >
                    Download Batch CSV
                  </button>
                )}
              </div>
            )}
          </div>
        );
      },
    },
  ];
  const handlePayment = (order) => {
    setSelectedOrderForPayment({
      batchId: order?._id,
      orderAmount: order?.blockedAmount?.finalQuoteCost?.unitAmount,
    });
    if (
      order?.blockedAmount?.finalQuoteCost?.unitAmount <
      walletDetails?.availableBalance?.unitAmount
    ) {
      setShowPayModal(true);
    } else {
      setOpenRechargeWalletModal(true);
    }
  };
  const onSuccessCreateBatch = (res) => {
    if (res.status === 200 || res.status === 201) {
      if (false) {
        setShowConfirmModal(true);
        setDragBatchId(res.data.batchId);
      } else if (batchName) {
        message.success("New Order Created Successfully");
        navigate(`/upload-images/${res?.data?.data?._id}`);
        setBatchName("");
      } else {
        setShowAddBatchModal(true);
      }
    }
  };
  const onErrorCreateBatch = (err) => {
    message.error(err);
  };
  const { mutate: createNewBatch } = useCreateNewBatch(
    onSuccessCreateBatch,
    onErrorCreateBatch
  );
  const onSuccessGetAllBatches = (res) => {
    if (res.status === 200) {
      setUsersList(res?.data?.data);
      setTotalCount(res.data.totalCount);
    }
  };
  const onErrorGetAllBatches = (err) => {
    console.log(err);
  };
  const { refetch: getAllBatches } = useGetAllBatches(
    "getAllBatches",
    pageNum,
    pageSize,
    onSuccessGetAllBatches,
    onErrorGetAllBatches
  );
  const onSuccessGetBatchCSV = (res) => {
    console.log(res);
    if (res.status === 200) {
      var blob = new Blob([res.data], {
        type: res.headers["content-type"],
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      let filename = res.headers["content-disposition"]
        .split("filename=")[1]
        .split(".")[0];
      link.setAttribute("download", `${filename}.csv`);
      document.body.appendChild(link);
      link.click();
    }
  };
  const onErrorGetBatchCSV = (err) => {
    console.log(err);
  };
  const { mutate: getBatchCSV } = useGetBatchCSV(
    onSuccessGetBatchCSV,
    onErrorGetBatchCSV
  );
  const handleCreateBtn = () => {
    setShowAddBatchModal(true);
  };
  const onPageChange = (page, size) => {
    if (page !== pageNum) {
      setPageNum(page);
    } else {
      setPageSize(size);
      setPageNum(1);
    }
  };

  const getCSVModal = () => {
    return (
      <Modal
        title="CSV Attachment"
        centered
        open={showMenu}
        footer={null}
        width="50%"
        height="auto"
        className="pay_modal_wrapper"
        onCancel={() => setShowMenu(false)}
      >
        <CSVDetails recordId={selectedRecordId} usersList={usersList} />
      </Modal>
    );
  };
  const addBatchName = () => {
    let payload = {
      deleteOld: true,
      name: batchName,
    };
    createNewBatch(payload);
  };
  const createNewOrder = () => {
    setShowConfirmModal(false);
    setShowAddBatchModal(true);
  };
  const resumeOrder = () => {
    setShowConfirmModal(false);
    navigate(`/upload-images/${draftBatchId}`);
  };
  const markPaymentSuccessfull = () => {
    setShowPayModal(false);
    getAllBatches();
    getWalletAccountDetails();
  };
  const getConfirmationModal = () => {
    return (
      <Modal
        title="Create New Order"
        open={showConfirmModal}
        onCancel={() => setShowConfirmModal(false)}
        className="confirm_modal_wrapper"
        centered
        footer={null}
        width={"45%"}
        height={"40dvh"}
      >
        <div className="confirm_modal_container">
          <div className="confirmation_text">
            You have an order in draft. Do you want to create a new order or
            resume the old one?
          </div>
          <div className="action_wrapper">
            <button className="resumeOrder" onClick={resumeOrder}>
              Resume Order
            </button>
            <Button
              width="210px"
              height="50px"
              text="Create New Order"
              handleClick={createNewOrder}
            />
          </div>
        </div>
      </Modal>
    );
  };
  const getAddBatchNameModal = () => {
    return (
      <Modal
        title="Create New Order - Add Batch Name"
        open={showAddBatchModal}
        onCancel={() => setShowAddBatchModal(false)}
        className="addBatch_modal_wrapper"
        centered
        footer={null}
        width={"45%"}
        height={"40dvh"}
      >
        <div className="addBatch_name_modal_container">
          <div className="input_wrapper">
            <input
              placeholder="Add Batch Name"
              value={batchName}
              onChange={(e) => setBatchName(e.target.value)}
            />
          </div>
          <div className="action_wrapper">
            <Button
              width="210px"
              height="50px"
              text="Create New Order"
              handleClick={addBatchName}
              isDisabled={!batchName}
            />
          </div>
        </div>
      </Modal>
    );
  };

  const getPayFromWallet = () => {
    return (
      <Modal
        centered
        open={showPayModal}
        footer={null}
        width="400px"
        height="202px"
        className="create_marketplace_modal_wrapper"
        onCancel={() => setShowPayModal(false)}
      >
        <PayFromWallet
          batch={selectedOrderForPayment}
          markpaymentSuccessful={markPaymentSuccessfull}
        />
      </Modal>
    );
  };
  const onSuccessGetBatchOverview = (res) => {
    if (res?.status === 200) {
      setOrderOverview(res?.data?.data);
    }
  };
  const onErrorGetBatchOverview = (err) => {
    console.log("err", err);
  };
  const { refetch: getBatchOverview } = useGetBatchOverview(
    "getBatchOverview",
    onSuccessGetBatchOverview,
    onErrorGetBatchOverview
  );
  return (
    <div className="order_list_main_wrapper">
      <div className="order_list_content_wrapper">
        <div className="order_list_action_wrapper">
          {/* <div className="welcome_message">
            Welcome to FlowEdit
            <span>John Doe</span>
          </div> */}

          <Button
            width="210px"
            height="50px"
            text="Create New Order"
            handleClick={handleCreateBtn}
          />
          {sourceData?.featureFlag?.showBatchOverview && (
            <button
              className="productionStatusBtn"
              onMouseEnter={() => setShowProdStatus(true)}
              onMouseLeave={() => setShowProdStatus(false)}
            >
              Production Status
            </button>
          )}
          {showProdStatus && (
            <div className="production_status_wrapper">
              <div className="data_wrapper">
                <div className="heading">Pending For Production</div>
                <div className="data_value">
                  {orderOverview?.prodPendingCount}
                </div>
              </div>
              <div className="break" />
              <div className="data_wrapper">
                <div className="heading">In Production</div>
                <div className="data_value">
                  {orderOverview?.prodInProgressCount}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="table_content_wrapper">
          <Table
            columns={columns}
            dataSource={usersList}
            scroll={{
              // x: 2100,
              y: `calc(100% )`,
            }}
            className="main_table"
            pagination={false}
          />
        </div>
        <div className="pagination_wrapper">
          <Pagination
            total={totalCount}
            // showTotal={false}
            defaultPageSize={10}
            showSizeChanger={false}
            current={pageNum}
            pageSize={pageSize}
            onChange={onPageChange}
          />
        </div>
      </div>
      {showConfirmModal && getConfirmationModal()}
      {showMenu && getCSVModal()}
      {showAddBatchModal && getAddBatchNameModal()}
      {showPayModal && getPayFromWallet()}
    </div>
  );
};
export default OrderList;
